/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListShadowMCPInventoryServersForUserSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListShadowMCPInventoryServersForUserRequest = {
  projectId: string;
  /**
   * The identifiers to attribute usage to, matched against the reported email or user id. Pass every identifier the subject is known by.
   */
  userKeys: Array<string>;
  /**
   * Inclusive start of the window to attribute calls from. Omit for the whole history.
   */
  from?: Date | undefined;
  /**
   * Exclusive end of the window to attribute calls from. Omit for the whole history.
   */
  to?: Date | undefined;
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListShadowMCPInventoryServersForUserSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListShadowMCPInventoryServersForUserSecurity$outboundSchema:
  z.ZodMiniType<
    ListShadowMCPInventoryServersForUserSecurity$Outbound,
    ListShadowMCPInventoryServersForUserSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listShadowMCPInventoryServersForUserSecurityToJSON(
  listShadowMCPInventoryServersForUserSecurity:
    ListShadowMCPInventoryServersForUserSecurity,
): string {
  return JSON.stringify(
    ListShadowMCPInventoryServersForUserSecurity$outboundSchema.parse(
      listShadowMCPInventoryServersForUserSecurity,
    ),
  );
}

/** @internal */
export type ListShadowMCPInventoryServersForUserRequest$Outbound = {
  project_id: string;
  user_keys: Array<string>;
  from?: string | undefined;
  to?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListShadowMCPInventoryServersForUserRequest$outboundSchema:
  z.ZodMiniType<
    ListShadowMCPInventoryServersForUserRequest$Outbound,
    ListShadowMCPInventoryServersForUserRequest
  > = z.pipe(
    z.object({
      projectId: z.string(),
      userKeys: z.array(z.string()),
      from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
      to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
      limit: z._default(z.int(), 50),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectId: "project_id",
        userKeys: "user_keys",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listShadowMCPInventoryServersForUserRequestToJSON(
  listShadowMCPInventoryServersForUserRequest:
    ListShadowMCPInventoryServersForUserRequest,
): string {
  return JSON.stringify(
    ListShadowMCPInventoryServersForUserRequest$outboundSchema.parse(
      listShadowMCPInventoryServersForUserRequest,
    ),
  );
}
